// src/components/Cards.js
import React, { useState } from "react";
import { Modal } from "antd";
import { IconPlus } from "@tabler/icons-react";
import ignite from "../Images/brandbird.png";
import intergrate from "../Images/brandbird2.png";
import Indemnify from "../Images/brandbird3.png";
import Individualize from "../Images/brandbird6.png";
import "./Cards.scss";
import { useTranslation } from "react-i18next";

export const Cards = () => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const [modalsVisible, setModalsVisible] = useState(
    new Array(t("cards.modals", { returnObjects: true })?.length || 3).fill(false)
  );

  // translations (arrays returned as objects)
  const nearFutureTitle = t("cards.nearFuture") || "";
  const subtitle = t("cards.subtitle") || "";
  const translatedCardData = t("cards.cardData", { returnObjects: true }) || [];
  const translatedModals = t("cards.modals", { returnObjects: true }) || [];

  // Local images mapped by card index
  const images = [ignite, intergrate, Indemnify, Individualize];

  // Map translated card data to include local images (no text duplication)
  const cardData = translatedCardData.map((c, i) => ({
    name: c?.name || "",
    description: c?.description || "",
    img: images[i] || "",
  }));

  // Quick-action items built from translated modals (title used directly)
  const quickActionItems = translatedModals.map((m) => ({
    text: m?.title || "",
    imageSrc: <IconPlus className={`icon ${isHovered ? "rotate" : ""}`} size={20} style={{ color: "#000000" }} />,
  }));

  const showModal = (index) => {
    const copy = [...modalsVisible];
    copy[index] = true;
    setModalsVisible(copy);
  };

  const hideModal = (index) => {
    const copy = [...modalsVisible];
    copy[index] = false;
    setModalsVisible(copy);
  };

  return (
    <div className="mt-10" id="nearfuture">
      <p className="flex justify-center text-4xl font-sans sm:text-4xl lg:text-5xl text-[#EF3B3B] font-semibold text-start wow fadeInUp mt-6">
        <span className="flex justify-center flex-col font-geo font-bold items-center">
          <svg
            width="129"
            height="27"
            viewBox="0 0 129 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mb-6"
          >
            <rect width="4" height="27" fill="white" />
            <rect x="25" width="4" height="27" fill="white" />
            <rect x="50" width="4" height="27" fill="white" />
            <rect x="75" width="4" height="27" fill="#C7C7C7" />
            <rect x="100" width="4" height="27" fill="white" />
            <rect x="125" width="4" height="27" fill="white" />
          </svg>
          {nearFutureTitle}
        </span>
      </p>

      <div className="p-4 flex justify-center text-xl font-sans text-gray-400 text-start mt-3 font-semibold leading-relaxed lg:mb-6 wow fadeInUp mb-4">
        {subtitle}
      </div>

      <div className="flex justify-center gap-5 flex-wrap font-sans">
        {cardData.map((content, index) => (
          <div className="card" key={index} style={{ backgroundImage: `url(${content.img})` }}>
            <div className="card-content h-full">
              <h2 className="card-title mb-10 font-bold text-xl">{content.name}</h2>
              <p className="card-body font-medium mt-3">{content.description}</p>
            </div>
          </div>
        ))}
      </div>
    <div
      className="flex flex-col  sm:!flex-row-reverse justify-around lg:mb-10 mb-1 mt-10 mx-3"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
        {quickActionItems.map((item, index) => (
          <div key={index} className="flex-item p-4 text-center flex flex-col text-white font-semibold font-sans">
            <div className="flex flex-col justify-center items-center mb-5">
              <p className="mb-4">{item.text}</p>
              <div
                className="bg-white rounded-full h-8 w-8 flex justify-center items-center"
                onClick={() => showModal(index)}
              >
                {item.imageSrc}
              </div>
            </div>
          </div>
        ))}
      </div>

      {translatedModals.map((m, index) => (
        <Modal
          key={index}
          width={1200}
          visible={modalsVisible[index]}
          onCancel={() => hideModal(index)}
          footer={null}
        >
          <div className="font-sans">
            <div className="p-4 text-center">
              <div className="text-5xl font-bold text-center text-[#EF3B3B] pt-3">{m?.title}</div>
              <div className="text-[#646464] font-semibold text-2xl">{m?.sideHeader || m?.sideheader}</div>
            </div>

            {m?.points && m.points.length > 0 && (
              <div className="flex flex-col sm:flex-row justify-center gap-9 text-xl mt-2 text-white">
                <div>
                  <ul className="list-disc list-inside">
                    {m.points.slice(0, Math.ceil(m.points.length / 2)).map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <ul className="list-disc list-inside">
                    {m.points.slice(Math.ceil(m.points.length / 2)).map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            <div
              className="text-2xl font-semibold text-center p-4 italic"
              style={{
                background:
                  "-webkit-linear-gradient(153deg, rgba(0,240,255,1) 0%, rgba(82,0,255,1) 52%, rgba(255,45,247,1) 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {m?.description}
            </div>
          </div>
        </Modal>
      ))}
    </div>
  );
};
